/**
 * This module was automatically generated by `ts-interface-builder`
 */
import * as t from "ts-interface-checker";
// tslint:disable:object-literal-key-quotes

export const ICommonUrls = t.iface([], {
  "help": "string",
  "helpAccessRules": "string",
  "helpAssistant": "string",
  "helpAssistantDataUse": "string",
  "helpFormulaAssistantDataUse": "string",
  "helpColRefs": "string",
  "helpConditionalFormatting": "string",
  "helpFilterButtons": "string",
  "helpLinkingWidgets": "string",
  "helpRawData": "string",
  "helpSuggestions": "string",
  "helpUnderstandingReferenceColumns": "string",
  "helpTriggerFormulas": "string",
  "helpTryingOutChanges": "string",
  "helpAutomations": "string",
  "helpWidgets": "string",
  "helpCustomWidgets": "string",
  "helpInstallAuditLogs": "string",
  "helpTeamAuditLogs": "string",
  "helpTelemetryLimited": "string",
  "helpEnterpriseOptIn": "string",
  "helpCalendarWidget": "string",
  "helpLinkKeys": "string",
  "helpFilteringReferenceChoices": "string",
  "helpSandboxing": "string",
  "helpSharing": "string",
  "helpStateStore": "string",
  "helpAPI": "string",
  "helpSummaryFormulas": "string",
  "helpAdminControls": "string",
  "helpFiddleMode": "string",
  "helpFormUrlValues": "string",
  "helpAirtableIntegration": "string",
  "helpCloudStorage": "string",
  "integrators": "string",
  "editionComparison": "string",
  "mcp": "string",
  "freeCoachingCall": "string",
  "contactSupport": "string",
  "termsOfService": t.union("string", "undefined"),
  "onboardingTutorialVideoId": "string",
  "plans": "string",
  "contact": "string",
  "templates": "string",
  "webinars": "string",
  "community": "string",
  "functions": "string",
  "formulaSheet": "string",
  "formulas": "string",
  "forms": "string",
  "openGraphPreviewImage": "string",
  "gristLabsCustomWidgets": "string",
  "gristLabsWidgetRepository": "string",
  "githubGristCore": "string",
  "githubSponsorGristLabs": "string",
  "versionCheck": "string",
  "attachmentStorage": "string",
  "signInWithGristRegister": "string",
  "signInWithGristHelp": "string",
  "signInWithGristDocs": "string",
});

const exportedTypeSuite: t.ITypeSuite = {
  ICommonUrls,
};
export default exportedTypeSuite;
